import type Store from "@ember-data/store";
import type ApplicationInstance from "@ember/application/instance";
import type FollowUpReason from "parog-web/models/follow-up-reason";

export function initialize(owner: ApplicationInstance): void {
  const store = owner.lookup("service:store") as Store;
  const nurseAssessment = store.createRecord("consultation-report-type", {
    id: "nurse-assessment"
  });

  const dietitianAssessment = store.createRecord("consultation-report-type", {
    id: "dietitian-assessment"
  });

  const psychologistInterview = store.createRecord("consultation-report-type", {
    id: "psychologist-interview"
  });

  const socialWorkerInterview = store.createRecord("consultation-report-type", {
    id: "social-worker-interview"
  });

  const therapeuticAssistance = store.createRecord("consultation-report-type", {
    id: "therapeutic-assistance"
  });

  const medicalImaging = store.createRecord("consultation-report-type", {
    id: "medical-imaging"
  });

  const inclusion = store.createRecord("consultation-report-type", {
    id: "inclusion"
  });

  const nephrologistConsultation = store.createRecord(
    "consultation-report-type",
    {
      id: "nephrologist-consultation"
    }
  );

  const gastroenterologistConsultation = store.createRecord(
    "consultation-report-type",
    {
      id: "gastroenterologist-consultation"
    }
  );

  const hepatologistConsultation = store.createRecord(
    "consultation-report-type",
    {
      id: "hepatologist-consultation"
    }
  );

  const oncologistConsultation = store.createRecord(
    "consultation-report-type",
    {
      id: "oncologist-consultation"
    }
  );

  const radiotherapistConsultation = store.createRecord(
    "consultation-report-type",
    {
      id: "radiotherapist-consultation"
    }
  );
  const surgeonConsultation = store.createRecord("consultation-report-type", {
    id: "surgeon-consultation"
  });

  const coordinatorFollowUpPoint = store.createRecord(
    "consultation-report-type",
    {
      id: "coordinator-follow-up-point"
    }
  );
  const initialInterview = store.createRecord("consultation-report-type", {
    id: "initial-interview"
  });
  const secondInterview = store.createRecord("consultation-report-type", {
    id: "second-interview"
  });
  const thirdInterview = store.createRecord("consultation-report-type", {
    id: "third-interview"
  });
  const therapeuticEducation = store.createRecord("consultation-report-type", {
    id: "therapeutic-education"
  });
  const lifeHygieneCoaching = store.createRecord("consultation-report-type", {
    id: "life-hygiene-coaching"
  });
  const individualPsychotherapy = store.createRecord(
    "consultation-report-type",
    {
      id: "individual-psychotherapy"
    }
  );

  const psychiatrist = store.createRecord("consultation-report-type", {
    id: "psychiatrist"
  });

  const addictologist = store.createRecord("consultation-report-type", {
    id: "addictologist"
  });

  const psychologist = store.createRecord("consultation-report-type", {
    id: "psychologist"
  });

  const groupPsychotherapy = store.createRecord("consultation-report-type", {
    id: "group-psychotherapy"
  });

  const recurringMonitoringPoint = store.createRecord(
    "consultation-report-type",
    {
      id: "recurring-monitoring-point"
    }
  );

  const ponctualMonitoringPoint = store.createRecord(
    "consultation-report-type",
    {
      id: "ponctual-monitoring-point"
    }
  );

  const nephroGenericConsultationList = [
    nurseAssessment,
    dietitianAssessment,
    psychologistInterview,
    socialWorkerInterview,
    therapeuticAssistance,
    medicalImaging,
    inclusion,
    nephrologistConsultation
  ];

  const cardioDiabetoConsultationList = [
    nurseAssessment,
    dietitianAssessment,
    psychologistInterview,
    socialWorkerInterview,
    therapeuticAssistance,
    medicalImaging,
    inclusion
  ];

  const digestConsultationList = [
    gastroenterologistConsultation,
    therapeuticAssistance,
    medicalImaging,
    inclusion
  ];

  const nephroPneumoConsultationList = [
    nephrologistConsultation,
    nurseAssessment,
    dietitianAssessment,
    psychologistInterview,
    socialWorkerInterview,
    therapeuticAssistance,
    medicalImaging,
    inclusion
  ];

  const hepatoConsultationList = [
    hepatologistConsultation,
    nurseAssessment,
    dietitianAssessment,
    psychologistInterview,
    socialWorkerInterview,
    therapeuticAssistance,
    medicalImaging,
    inclusion
  ];

  const oncoConsultationList = [
    oncologistConsultation,
    radiotherapistConsultation,
    surgeonConsultation,
    coordinatorFollowUpPoint,
    medicalImaging,
    initialInterview,
    secondInterview,
    thirdInterview,
    inclusion
  ];

  const mentalConsultationList = [
    therapeuticEducation,
    lifeHygieneCoaching,
    individualPsychotherapy,
    psychiatrist,
    addictologist,
    psychologist,
    groupPsychotherapy,
    recurringMonitoringPoint,
    ponctualMonitoringPoint,
    medicalImaging
  ];

  const data = {
    "nephro-generic": nephroGenericConsultationList,
    "nephro-mrc": nephroGenericConsultationList,
    "nephro-transplant": nephroPneumoConsultationList,
    "nephro-donor": nephroPneumoConsultationList,
    "pneumo-transplant": nephroPneumoConsultationList,
    "pneumo-generic": nephroPneumoConsultationList,
    "hepato-transplant": hepatoConsultationList,
    "hepato-generic": hepatoConsultationList,
    "onco-breast-cancer-tnm0": oncoConsultationList,
    "onco-breast-cancer": oncoConsultationList,
    "onco-lymphoma-cancer": oncoConsultationList,
    "onco-myeloma-cancer": oncoConsultationList,
    "onco-hemato-cancer": oncoConsultationList,
    "onco-colon-cancer": oncoConsultationList,
    "onco-lung-cancer": oncoConsultationList,
    "onco-prostate-cancer": oncoConsultationList,
    "onco-ovarian-cancer": oncoConsultationList,
    "onco-testicular-cancer": oncoConsultationList,
    "onco-brain-cancer": oncoConsultationList,
    "onco-pancreatic-cancer": oncoConsultationList,
    "onco-liver-cancer": oncoConsultationList,
    "onco-kidney-cancer": oncoConsultationList,
    "onco-stomach-cancer": oncoConsultationList,
    "onco-cervix-cancer": oncoConsultationList,
    "onco-skin-cancer": oncoConsultationList,
    "onco-generic": oncoConsultationList,
    "mental-bipolar": mentalConsultationList,
    "mental-depression": mentalConsultationList,
    "mental-generic": mentalConsultationList,
    "diabeto-dt2": cardioDiabetoConsultationList,
    "diabeto-generic": cardioDiabetoConsultationList,
    "cardio-transplant": cardioDiabetoConsultationList,
    "cardio-heart-failure": cardioDiabetoConsultationList,
    "cardio-generic": cardioDiabetoConsultationList,
    "digest-crohn": digestConsultationList,
    "digest-rch": digestConsultationList,
    "digest-generic": digestConsultationList
  };

  Object.entries(data).forEach(([FollowUpReasonName, ConsultationList]) => {
    const FollowUpReason = store.peekRecord(
      "follow-up-reason",
      FollowUpReasonName
    ) as FollowUpReason;
    FollowUpReason.consultationReportTypes = ConsultationList;
  });
}

export default {
  after: "follow-up-reasons",
  initialize
};
